export const colors = {
  common: {
    black: '#282828',
    white: '#ffffff',
  },
  primary: {
    light: '#83bf9b',
    main: '#64b082',
    dark: '#467b5b',
  },
  secondary: {
    light: '#a487ec',
    main: '#8e6ae8',
    dark: '#634aa2',
  },
  appBackground: {
    light: '#ffeed7',
    main: '#ffe8c2',
    dark: '#ffe0ad',
  },
}

export const app = {
  input: { borderRadius: '0.25rem' },
  button: { borderRadius: '0.5rem' },
  widget: { borderRadius: '1rem' },
}
